module.exports = __webpack_public_path__ + "img/Gestor1.a401c5a2.png";